import { useGraphqlRequestContext } from '../../../../utils/provider/GraphqlRequestContext'

export const useChangeOutsideStatus = () => {
  const { backendClient } = useGraphqlRequestContext()

  const outsideRequest = async ({ paperId }: { paperId: string }) => {
    await backendClient.updateOutsideRequestStatus({ where: { id: paperId } })
  }
  return { outsideRequest }
}
